import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ExtensionPoints } from "abweb/utils/plugins/ExtensionPoints";

/**
 * A collection of extension points to support application theming.
 */
export class AbThemingExtensionPoints {}
_defineProperty(AbThemingExtensionPoints, "applicationThemes", ExtensionPoints.syncKeyedValues(theme => theme.id));
_defineProperty(AbThemingExtensionPoints, "applicationThemeTweaks", ExtensionPoints.syncKeyedValues(theme => theme.themeClassName));
//# sourceMappingURL=AbThemingExtensionPoints.js.map
